import apiClient from './api'

export const ibanApi = {
  /**
   * Validiert eine IBAN und gibt BIC sowie Bank-Informationen zurück
   * @param {string} iban - Die zu validierende IBAN
   * @returns {Promise<Object>} Validierungsergebnis
   */
  async validateIban(iban) {
    try {
      const response = await apiClient.post('/iban/validate', { iban })
      


      if (response.data.success && response.data.data) {
        return response.data.data
      } else if (response.data.success === false) {
        throw new Error(response.data.error || 'IBAN-Validierung fehlgeschlagen')
      } else {

        return response.data
      }
    } catch (error) {
      console.error('Fehler bei der IBAN-Validierung:', error?.message || 'Unbekannter Validierungsfehler')
      throw error
    }
  }
}
